import { BoxProps, TextProps } from '@jfs/ui-new'
import { ViewProps } from 'react-native'
import { Colors } from '../../util/util'

const overRideNav = (breakpoint: number) => {
  if (breakpoint < 850) {
    return {
      marginLeft: -220,
    } as ViewProps
  }
}

const styles = {
  alert: {
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  } as BoxProps,
  container: {
    height: '100vh',
    minHeight: 460,
    flexDirection: 'row',
    flex: 1,
  } as BoxProps,
  childContainer: {
    flex: 1,
    minHeight: '100vh',
    backgroundColor: Colors.HALF_WHITE,
    justifyContent: 'space-between',
    overflow: 'auto',
  } as BoxProps,
  gradientBgStyle: (breakPointValue: number) =>
    ({
      width: 220,
      height: '100%',
      ...overRideNav(breakPointValue),
    } as ViewProps),
  logo: {
    flexDirection: 'row',
    height: 82,
    alignItems: 'center',
    marginStart: 15,
    paddingHorizontal: 16,
  } as BoxProps,
  logoText: {
    fontWeight: '800',
    marginLeft: 8,
    color: 'WHITE',
    fontSize: 20,
  } as TextProps,
  menuFooterCOntainer: {
    paddingBottom: 16,
    paddingHorizontal: 16,
  } as BoxProps,
  settlmentNote: {
    marginTop: 'auto',
    marginLeft: 16,
    padding: 2,
  } as BoxProps,
  containerInner: {
    width: '100%',
    flex: 1,
  } as BoxProps,
}

export default styles
